module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }